export default "__VITE_ASSET__a705de92__"